module.exports = __webpack_public_path__ + "img/secondary_bg1.df8b344a.png";